export default __webpack_public_path__ + "images/right-arrow.png?dce94c05457b0562803d00c4d9a245f3";